/**
 * Same offer rule as service-menu offer-items API / itemExtendedFieldsMapper:
 * item is on offer when originalPrice > 0 && price < originalPrice.
 * discountPercentage = round(((original - price) / original) * 100)
 */
const calculateDiscountPercentage = (originalPrice = 0, price = 0) => {
  const original = Number(originalPrice) || 0
  const current = Number(price) || 0
  if (original <= 0 || current >= original) return 0
  return Math.round(((original - current) / original) * 100)
}

const isOfferItem = (originalPrice = 0, price = 0) => {
  const original = Number(originalPrice) || 0
  const current = Number(price) || 0
  return original > 0 && current < original
}

/**
 * Map Add/Edit Item form state into a shared preview model for Web/Mobile cards.
 */
export const buildItemPreviewProps = ({
  values = {},
  selectedTags = [],
  mode = "add",
  language = "eng",
  getImagePreviewSrc,
} = {}) => {
  const lang = String(language || "").toLowerCase()
  // Portal Arabic locale is "sa" (also accept ar/ara).
  const isAr = lang === "sa" || lang === "ar" || lang === "ara" || lang === "arabic"
  const name = isAr
    ? values.nameAr || values.nameEn || ""
    : values.nameEn || values.nameAr || ""

  const price = Number(values.itemPrice)
  const originalPrice = Number(values.originalPrice)
  const hasPrice = Number.isFinite(price)
  const onOffer =
    hasPrice && isOfferItem(originalPrice, price)
  const discountPercent = onOffer
    ? calculateDiscountPercentage(originalPrice, price)
    : 0
  const compareAtPrice = onOffer ? originalPrice : null

  // getImagePreviewSrc only resolves URLs/files when mode === "add"
  // (EditItem uses the same trick for its thumbnail).
  const imageFromHelper =
    typeof getImagePreviewSrc === "function"
      ? getImagePreviewSrc("add", values)
      : null
  let image = imageFromHelper || ""
  if (!image && values.imageFile) {
    try {
      image = URL.createObjectURL(values.imageFile)
    } catch (_e) {
      image = ""
    }
  }
  if (!image && values.imageUrl) {
    image = values.imageUrl
  }
  void mode

  const displayOrderOf = tag => {
    if (!tag || typeof tag === "string") return Number.POSITIVE_INFINITY
    const order = Number(tag.displayOrder)
    return Number.isFinite(order) ? order : Number.POSITIVE_INFINITY
  }

  const badges = (Array.isArray(selectedTags) ? selectedTags : [])
    .slice()
    .sort((a, b) => displayOrderOf(a) - displayOrderOf(b))
    .map(tag => {
      if (!tag) return ""
      if (typeof tag === "string") return tag
      if (isAr) {
        return tag.labelAr || tag.nameAr || tag.label || tag.name || ""
      }
      return tag.label || tag.name || tag.labelAr || tag.nameAr || ""
    })
    .filter(Boolean)

  return {
    name: name || "Item name",
    image,
    price: hasPrice ? price : null,
    compareAtPrice,
    discountPercent: discountPercent > 0 ? discountPercent : null,
    isOffer: onOffer && discountPercent > 0,
    badges,
    isFastMoving: values.isFastMoving === true,
  }
}
